/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountData } from './AccountData';
import {
    AccountDataFromJSON,
    AccountDataFromJSONTyped,
    AccountDataToJSON,
    AccountDataToJSONTyped,
} from './AccountData';

/**
 * 
 * @export
 * @interface AccountDataSnapshot
 */
export interface AccountDataSnapshot {
    /**
     * 
     * @type {number}
     * @memberof AccountDataSnapshot
     */
    revisionNumber?: number | null;
    /**
     * 
     * @type {AccountDataSnapshotModificationTypeEnum}
     * @memberof AccountDataSnapshot
     */
    modificationType?: AccountDataSnapshotModificationTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountDataSnapshot
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AccountDataSnapshot
     */
    updatedBy: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof AccountDataSnapshot
     */
    modifiedFields: Set<string>;
    /**
     * 
     * @type {AccountData}
     * @memberof AccountDataSnapshot
     */
    account: AccountData;
}


/**
 * @export
 */
export const AccountDataSnapshotModificationTypeEnum = {
    New: 'New',
    Updated: 'Updated',
    Deleted: 'Deleted'
} as const;
export type AccountDataSnapshotModificationTypeEnum = typeof AccountDataSnapshotModificationTypeEnum[keyof typeof AccountDataSnapshotModificationTypeEnum];


/**
 * Check if a given object implements the AccountDataSnapshot interface.
 */
export function instanceOfAccountDataSnapshot(value: object): value is AccountDataSnapshot {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('modifiedFields' in value) || value['modifiedFields'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function AccountDataSnapshotFromJSON(json: any): AccountDataSnapshot {
    return AccountDataSnapshotFromJSONTyped(json, false);
}

export function AccountDataSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDataSnapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'revisionNumber': json['revisionNumber'] == null ? undefined : json['revisionNumber'],
        'modificationType': json['modificationType'] == null ? undefined : json['modificationType'],
        'updatedAt': (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'],
        'modifiedFields': new Set(json['modifiedFields']),
        'account': AccountDataFromJSON(json['account']),
    };
}

export function AccountDataSnapshotToJSON(json: any): AccountDataSnapshot {
    return AccountDataSnapshotToJSONTyped(json, false);
}

export function AccountDataSnapshotToJSONTyped(value?: AccountDataSnapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revisionNumber': value['revisionNumber'],
        'modificationType': value['modificationType'],
        'updatedAt': value['updatedAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'modifiedFields': Array.from(value['modifiedFields'] as Set<any>),
        'account': AccountDataToJSON(value['account']),
    };
}

